import ManageColumnsModal from '@Quarantine/RiskAI/ManageColumnsModal';
import { Button } from '@tonic-one/react';
import { ColumnsIcon } from '@tonic-one/react-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const QuarantineManageColumn = (props: {
  columnOrder: string[];
  columnNames: { [columnId: string]: string };
  columnHideIds: string[];
  onColumnOrderChange: (columnOrder: string[]) => void;
  onColumnHideIdsChange: (columnHideIds: string[]) => void;
}) => {
  const {
    columnOrder,
    columnNames,
    columnHideIds,
    onColumnOrderChange,
    onColumnHideIdsChange,
  } = props;
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setIsOpen(true)} variant="secondary" height="6x">
        <ColumnsIcon mr="2x" />
        {t('log.button.manageColumns')}
      </Button>
      {isOpen && (
        <ManageColumnsModal
          visible={isOpen}
          columnOrder={columnOrder}
          columnNames={columnNames}
          columnHideIds={columnHideIds}
          onSave={(order, hideIds) => {
            onColumnOrderChange(order);
            onColumnHideIdsChange(hideIds);
          }}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};
